import { Plus, FolderKanban, ArrowRightLeft, Home, LayoutDashboard, Target, FolderOpen, Globe, ClipboardList, Building2 } from 'lucide-react'
import type { NavItem } from '../components/ui/AppShell'

/**
 * Level-2 primary nav for the PM section (shared by the PM dashboard and the
 * in-program shell). "Home" and "+ New Program" are the same screen (the
 * workflow picker). DEV-732: the recent-programs list is rendered below this
 * via AppShell `sidebarExtra`; the standalone Market page is dropped from the
 * nav (reached as a module review surface within a program).
 */
export const PM_NAV: NavItem[] = [
  { label: 'New Program', to: '/home', icon: Plus, end: true },
  { label: 'Programs', to: '/programs', icon: FolderKanban },
  { label: 'Transit', to: '/transit', icon: ArrowRightLeft },
]

/** Level-2 primary nav for the Transit section; its transitions list sits below. */
export const TRANSIT_NAV: NavItem[] = [
  { label: 'New Transition', to: '/transit', icon: Plus, end: true },
]

/** Level-2 primary nav for the Exec section. */
export const EXEC_NAV: NavItem[] = [
  { label: 'Home', to: '/exec', icon: Home, end: true },
  { label: 'Dashboard', to: '/exec/dashboard', icon: LayoutDashboard },
  { label: 'Goals', to: '/exec/goals', icon: Target },
  { label: 'Portfolios', to: '/exec/portfolio-groups', icon: FolderOpen },
  { label: 'DIB', to: '/exec/dib', icon: Globe },
]

/** Level-2 primary nav for the Reviewer section. */
export const REVIEWER_NAV: NavItem[] = [
  { label: 'Tasks', to: '/review/tasks', icon: ClipboardList },
  { label: 'Vendors', to: '/review/vendors', icon: Building2 },
]
